<template>
  <div class="chart" v-if="show">
    <div class="tours">
      <div>景点范围</div>
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="el-dropdown-link">
          {{ toursName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, index) in toursList"
            :key="index"
            :command="item"
            >{{ item.name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="add">
      <div class="add-name">
        {{ ALLYearData.name }}
        <span>累计接待</span>
      </div>
      <div class="add-value">
        {{ ALLYearData.value }}
        <span>人次</span>
      </div>
    </div>
    <div class="date">
      <div class="date-title">日期范围</div>
      <div class="date-text">
        <div
          v-for="(item, index) in dateList"
          :key="index"
          class="date-item"
          :class="day == item.value ? 'active' : ''"
          @click="day = item.value"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="view">
      <div class="appointCount view-item">
        <div class="view-title">门票</div>
        <div class="view-data">{{ appointCount | numberFormatFilter }}</div>
        <div>
          <div class="view-independent">
            <span>散客：</span>{{ appointCount_independent }}
          </div>
          <div class="view-team">
            <span>团队：</span>{{ appointCount_team }}
          </div>
        </div>
      </div>
      <div class="checkinCount view-item">
        <div class="view-title">人园</div>
        <div class="view-data">{{ checkinCount | numberFormatFilter }}</div>
        <div class="view-independent">
          <span>散客：</span>{{ checkinCount_independent }}
        </div>
        <div class="view-team"><span>团队：</span>{{ checkinCount_team }}</div>
      </div>
    </div>
    <div class="health background">
      <div class="health-title">今日核酸</div>
      <div class="health-data">
        <div class="health-item1">
          <span>24h:</span>{{ nucleinData["one"] }}
        </div>
        <div class="health-item2">
          <span>48h:</span>{{ nucleinData["two"] }}
        </div>
        <div class="health-item3">
          <span>72h:</span>{{ nucleinData["three"] }}
        </div>
      </div>
    </div>
    <div class="health background">
      <div class="health-title">健康状态</div>
      <div class="health-data">
        <div class="health-item1"><span>绿码:</span>{{ healthCount[0] }}</div>
        <div class="health-item2"><span>黄码:</span>{{ healthCount[1] }}</div>
        <div class="health-item3"><span>红码:</span>{{ healthCount[2] }}</div>
      </div>
    </div>
    <div class="background">
      <div id="topChart" :style="{ height: myTopHeight + 'px' }"></div>
    </div>
    <div class="background">
      <div id="Timeline"></div>
      <div class="Timelines">
        <div
          @click="changeTime(index)"
          v-for="(item, index) in timelineDate"
          :key="index"
          :style="{
            color: item.color,
            backgroundColor: item.show ? item.color1 : 'rgb(233, 231, 231)',
          }"
        >
          <span :style="{ backgroundColor: item.color }"></span>
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="background" style="display: flex; align-items: center">
      <div id="NewOld"></div>
      <div class="pieRight">
        <div class="pie-item">
          <div class="pie-item-title"></div>
          <div class="pie-item-value">人数</div>
          <div class="pie-item-value">占比</div>
        </div>
        <div v-for="(item, index) in NewOldData" :key="index" class="pie-item">
          <div class="pie-item-title1">
            <div
              class="pie-item-title-inner"
              :style="{ color: item.color, backgroundColor: item.color1 }"
            >
              <span :style="{ backgroundColor: item.color }"></span>
              {{ item.name }}
            </div>
          </div>
          <div class="pie-item-value">{{ item.value }}</div>
          <div class="pie-item-rate">{{ item.rate | percentageFilter }}</div>
        </div>
      </div>
    </div>
    <div class="background" style="display: flex; align-items: center">
      <div id="gender"></div>
      <div class="pieRight">
        <div class="pie-item">
          <div class="pie-item-title"></div>
          <div class="pie-item-value">人数</div>
          <div class="pie-item-value">占比</div>
        </div>
        <div v-for="(item, index) in genderData" :key="index" class="pie-item">
          <div class="pie-item-title1">
            <div
              class="pie-item-title-inner"
              :style="{ color: item.color, backgroundColor: item.color1 }"
            >
              <span :style="{ backgroundColor: item.color }"></span>
              {{ item.name }}
            </div>
          </div>
          <div class="pie-item-value">{{ item.value }}</div>
          <div class="pie-item-rate">{{ item.rate | percentageFilter }}</div>
        </div>
      </div>
    </div>
    <div class="background" style="display: flex; align-items: center">
      <div id="age"></div>
      <div class="pieRight">
        <div class="pie-item">
          <div class="pie-item-title"></div>
          <div class="pie-item-value">人数</div>
          <div class="pie-item-value">占比</div>
        </div>
        <div v-for="(item, index) in ageData" :key="index" class="pie-item">
          <div
            class="pie-item-title"
            :style="{ color: item.color, backgroundColor: item.color1 }"
          >
            <span :style="{ backgroundColor: item.color }"></span>
            {{ item.name }}
          </div>
          <div class="pie-item-value">{{ item.value }}</div>
          <div class="pie-item-rate">{{ item.rate | percentageFilter }}</div>
        </div>
      </div>
    </div>
    <div class="more">更多大数据分析，请登录WEB端查看</div>
  </div>
</template>
<script>
import { numFormat, dateFormat, toFixed } from "@/utils.js";
export default {
  data() {
    return {
      show: false, //是否有权限查看图表
      toursName: "青浦文旅所有景点",
      tourId: "ALL", //景点范围
      toursList: {}, //景点列表
      ALLYearData: {}, //年总累计
      //日期范围
      day: 0,
      paramsData: "",
      dateList: [
        {
          name: "今天",
          value: 0,
        },
        {
          name: "昨天",
          value: 1,
        },
        {
          name: "近7天",
          value: 7,
        },
        {
          name: "近30天",
          value: 30,
        },
      ],
      //累计门票
      appointCount: null,
      appointCount_independent: null,
      appointCount_team: null,
      //累计入园
      checkinCount: null,
      checkinCount_independent: null,
      checkinCount_team: null,
      //健康状态
      healthCount: [],
      //实时到访人数
      timelineDate: [
        {
          num: 0,
          show: true,
          name: "当前",
          color: "#8385ea",
          color1: "#f2f2fc",
        },
        {
          num: 1,
          show: true,
          name: "1天前",
          color: "#60bfff",
          color1: "#eef9ff",
        },
        {
          num: 7,
          show: true,
          name: "7天前",
          color: "#eea14f",
          color1: "#fdf4ed",
        },
      ],
      NewOldData: "",
      genderData: "",
      ageData: "",
      myTopHeight: "100",
      nucleinData: "",
    };
  },
  filters: {
    numberFormatFilter(val) {
      if (isNaN(val) || val === null) return "";
      return numFormat(val);
    },
    percentageFilter(val) {
      return toFixed(val * 100, 2) + "%";
    },
  },
  watch: {
    day(val) {
      let data = [this.getNumDate(val), this.getNumDate(1)];
      if (val == 0) {
        data[1] = this.getNumDate(0);
      }
      this.paramsData = {
        appointDateStart: data[0],
        appointDateEnd: data[1],
      };
      this.getData();
      this.getView();
      this.getCheckTopData();
      this.getNewOldData();
      this.getNewOldData();
      this.getGenderData();
      this.getAgeData();
    },
    tourId() {
      this.getData();
      this.getView();
      this.getTimelineData();
      this.getNewOldData();
      this.getNewOldData();
      this.getGenderData();
      this.getAgeData();
    },
  },
  created() {
    this.$axios.get("/getInfo").then((res) => {
      if (res.roles) {
        if (res.roles.indexOf("travel_admin") != -1) {
          this.show = true;
        } else {
          this.show = false;
        }
      }
    });
    this.paramsData = {
      appointDateStart: this.getNumDate(0),
      appointDateEnd: this.getNumDate(0),
    };
    this.$axios.get("/book/tours?type=1").then((res) => {
      this.toursList = res.data.rows;
      this.toursList.unshift({
        name: "青浦文旅所有景点",
        id: "ALL",
      });
    });
    this.getData();
    this.getView();
    this.getCheckTopData();
    this.getTimelineData();
    this.getNewOldData();
    this.getGenderData();
    this.getAgeData();
  },
  methods: {
    //实时到访人数时间选择
    changeTime(index) {
      this.$set(
        this.timelineDate[index],
        "show",
        !this.timelineDate[index].show
      );
      this.getTimelineData();
    },
    //选择景点范围
    handleCommand(val) {
      this.tourId = val.id;
      this.toursName = val.name;
    },
    // 获取图表实例（如果未初始化则初始化，若已初始化则直接返回实例）
    getChart(domId) {
      let dom = document.getElementById(domId);
      let instance = this.$echarts.getInstanceByDom(dom);
      if (instance) {
        return instance;
      } else {
        let chart = this.$echarts.init(dom);
        return chart;
      }
    },
    //获取前num的时间
    getNumDate(num) {
      let date = new Date();
      date.setDate(date.getDate() - num);
      let DayBefore = dateFormat("YYYY-mm-dd", date);
      return DayBefore;
    },
    // 获取累计门票
    getData() {
      let year = dateFormat("YYYY", new Date());
      this.$set(this.ALLYearData, "name", year);
      let url = "/image/all";
      if (this.tourId != "ALL") {
        url = "/image/all?tourId=" + this.tourId;
      }
      this.$axios.get(url).then((res) => {
        this.$set(
          this.ALLYearData,
          "value",
          res.data.actualViews.toLocaleString()
        );
      });
    },
    //获取顶部图卡数据
    getView() {
      let data = {
        appointDateStart: this.paramsData.appointDateStart,
        appointDateEnd: this.paramsData.appointDateEnd,
      };
      let data1 = {};
      if (this.tourId != "ALL") {
        data.tourId = this.tourId;
        data1.tourId = this.tourId;
      }
      this.$axios
        .get("/image/selectNuclein", {
          params: data1,
        })
        .then((res) => {
          this.nucleinData = res.data;
        });
      this.$axios
        .get("/image/view", {
          params: data,
        })
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.appointCount = res.data[0].allViews;
            this.checkinCount = res.data[0].actualViews;
            this.appointCount_independent = res.data[0].noteamallViews;
            this.appointCount_team = res.data[0].teamallViews;
            this.checkinCount_independent = res.data[0].noteamactualViews;
            this.checkinCount_team = res.data[0].teamactualViews;
          } else {
            console.log("Failed to resolve response data! Path: /image/view");
          }
        });
      // 获取健康状态统计
      this.$axios
        .get("/image/health", {
          params: data,
        })
        .then((res) => {
          let gData = res.data.find((item) => item.health == "绿码") || {
            health: "绿码",
            count: 0,
          };
          let yData = res.data.find((item) => item.health == "黄码") || {
            health: "黄码",
            count: 0,
          };
          let rData = res.data.find((item) => item.health == "红码") || {
            health: "红码",
            count: 0,
          };
          this.healthCount = [gData.count, yData.count, rData.count];
        });
    },
    //获取人气排名数据
    getCheckTopData() {
      this.$axios
        .get("/image/top", {
          params: this.paramsData,
        })
        .then((res) => {
          let mydata = res.data;
          if (mydata.length > 2) {
            this.myTopHeight = mydata.length * 60;
          } else {
            if (mydata.length == 2) {
              this.myTopHeight = 160;
            } else {
              this.myTopHeight = 120;
            }
          }
          this.$nextTick(() => {
            this.initCheckTopChart(mydata);
          });
        });
    },
    // 获取实时客流分析数据
    getTimelineData() {
      // 前一天
      let URLList = [];
      let chartname = [];
      let colorList = [];
      this.timelineDate.forEach((element) => {
        if (element.show) {
          let paramsData = {
            apponitDate: this.getNumDate(element.num),
          };
          if (this.tourId != "ALL") {
            paramsData.tourId = this.tourId;
          }
          URLList.push(
            this.$axios.get("/image/hour", {
              params: paramsData,
            })
          );
          chartname.push(element.name);
          colorList.push(element.color);
        }
      });

      // 同时请求今天和昨天
      Promise.all(URLList).then((data) => {
        let chartList = [];
        data.forEach((element) => {
          let dataCmp = [];
          element.data.forEach((item) => {
            dataCmp.push(item.count);
          });
          chartList.push(dataCmp);
        });
        this.initTimelineChart(chartList, chartname, colorList);
      });
    },
    //获取新老客户对比数据
    getNewOldData() {
      let data = {
        startTime: this.paramsData.appointDateStart,
        endTime: this.paramsData.appointDateEnd,
      };
      if (this.tourId != "ALL") {
        data.tourId = this.tourId;
      }
      this.$axios
        .get("/image/selectTourUserType", { params: data })
        .then((res) => {
          let data = res.data;
          let dataList = [
            {
              name: "新",
              value: eval(data.newUserCount.join("+")),
              rate: 0,
              color: "#9092f7",
              color1: "#f2f2fa",
            },

            {
              name: "老",
              value: eval(data.oldUserCount.join("+")),
              rate: 0,
              color: "#66bcf9",
              color1: "#eef9ff",
            },
          ];
          let total = dataList[0].value + dataList[1].value;
          dataList[0].rate = dataList[0].value / total;
          dataList[1].rate = dataList[1].value / total;
          this.NewOldData = dataList;
          this.initNewOldChart(dataList);
        });
    },
    //获取性别分布数据
    getGenderData() {
      let data = {
        appointDateStart: this.paramsData.appointDateStart,
        appointDateEnd: this.paramsData.appointDateEnd,
      };
      if (this.tourId != "ALL") {
        data.tourId = this.tourId;
      }
      let url = "/image/sex";
      if (this.day == 0) {
        url = "/image/todaysex";
      }
      this.$axios.get(url, { params: data }).then((res) => {
        let data = [
          {
            name: "女",
            value: 0,
            rate: 0,
            color: "#9092f7",
            color1: "#f2f2fa",
          },
          {
            name: "男",
            value: 0,
            rate: 0,
            color: "#66bcf9",
            color1: "#eef9ff",
          },
        ];
        for (let element of res.data) {
          if (element.name == "0") {
            data[0].value = element.value;
            data[0].rate = element.rate;
          }
          if (element.name == "1") {
            data[1].value = element.value;
            data[1].rate = element.rate;
          }
        }
        this.genderData = data;
        this.initGenderChart(data);
      });
    },
    //获取年龄分布数据
    getAgeData() {
      let data = {
        appointDateStart: this.paramsData.appointDateStart,
        appointDateEnd: this.paramsData.appointDateEnd,
      };
      if (this.tourId != "ALL") {
        data.tourId = this.tourId;
      }
      let url = "/image/year";
      if (this.day == 0) {
        url = "/image/todayyear";
      }
      this.$axios.get(url, { params: data }).then((res) => {
        let data = [
          {
            name: "60岁以上",
            value: 0,
            rate: 0,
            color: "#9f5de5",
            color1: "#f8f4fc",
          },
          {
            name: "46-60岁",
            value: 0,
            rate: 0,
            color: "#ea6e79",
            color1: "#f7efef",
          },
          {
            name: "36-45岁",
            value: 0,
            rate: 0,
            color: "#ffd541",
            color1: "#f7f5ee",
          },
          {
            name: "26-35岁",
            value: 0,
            rate: 0,
            color: "#50d36d",
            color1: "#eaf1eb",
          },
          {
            name: "18-25岁",
            value: 0,
            rate: 0,
            color: "#43d1d5",
            color1: "#ebf1f1",
          },
          {
            name: "18岁以下",
            value: 0,
            rate: 0,
            color: "#41a3fe",
            color1: "#e3ecf5",
          },
        ];
        data = data.map((item) => {
          for (const iterator of res.data) {
            if (iterator.name == item.name) {
              item.value = iterator.value;
              item.rate = iterator.rate;
              break;
            }
          }
          return item;
        });
        this.ageData = data;
        this.initAgeChart(data);
      });
    },
    // 初始化实时图表
    initTimelineChart(data, dataCmp, colorList) {
      let chart = this.getChart("Timeline");
      let myseries = [];
      let hour = new Date().getHours();
      for (const key in dataCmp) {
        myseries.push({
          name: dataCmp[key],
          data: dataCmp[key] == "当前" ? data[key].slice(0, hour) : data[key],
          type: "line",
          symbolSize: 3,
          areaStyle: {
            color: this.timelineDate[key].color1,
          },
          lineStyle: {
            width: dataCmp[key] == "当前" ? 3 : 1,
          },
        });
      }
      chart.setOption(
        {
          title: {
            text: "实时到访人数",
            left: "0",
            top: "0",
          },
          xAxis: {
            type: "category",
            data: [
              "0:00",
              "1:00",
              "2:00",
              "3:00",
              "4:00",
              "5:00",
              "6:00",
              "7:00",
              "8:00",
              "9:00",
              "10:00",
              "11:00",
              "12:00",
              "13:00",
              "14:00",
              "15:00",
              "16:00",
              "17:00",
              "18:00",
              "19:00",
              "20:00",
              "21:00",
              "22:00",
              "23:00",
            ],
            axisLabel: {
              textStyle: {
                fontSize: 10,
              },
            },
            // axisLine: {
            //   lineStyle: {
            //     fontSize: 8,
            //   },
            // },
            // axisTick: {
            //   lineStyle: {
            //     fontSize: 8,
            //   },
            // },
          },
          yAxis: {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 10,
              },
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
          },
          tooltip: {
            show: true,
            trigger: "axis",
          },
          grid: {
            left: "0",
            right: "4%",
            bottom: "3%",
            top: "70px",
            containLabel: true,
          },
          dataZoom: {
            type: "inside",
            filterMode: "none",
          },
          color: colorList,
          series: myseries,
        },
        true
      );
    },
    //初始化新老游客分析
    initNewOldChart(data) {
      let chart = this.getChart("NewOld");
      chart.setOption({
        title: {
          text: "新老游客",
          left: "0",
          top: "0",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        color: ["#9092f7", "#66bcf9"],
        series: [
          {
            type: "pie",
            radius: ["90%", "40%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            left: "0",
            top: "20px",
            right: "4%",
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
              },
            },
            data: data,
          },
        ],
      });
    },
    // 初始化性别分布图表
    initGenderChart(genderData) {
      let chart = this.getChart("gender");
      chart.setOption({
        title: {
          text: "性别分布",
          left: "0",
          top: "0",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        color: ["#9092f7", "#66bcf9"],
        series: [
          {
            name: "性别",
            type: "pie",
            radius: ["90%", "40%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            left: "0",
            top: "20px",
            right: "4%",
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
              },
            },
            data: genderData,
          },
        ],
      });
    },
    // 初始化年龄分布图表
    initAgeChart(data) {
      let chart = this.getChart("age");
      chart.setOption({
        title: {
          text: "年龄分布",
          left: "0",
          top: "0",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        color: [
          "#9f5de5",
          "#ea6e79",
          "#ffd541",
          "#50d36d",
          "#43d1d5",
          "#41a3fe",
        ],
        series: [
          {
            name: "年龄",
            type: "pie",
            radius: ["90%", "40%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            left: "0",
            top: "20px",
            right: "4%",
            emphasis: {
              label: {
                show: true,
                fontSize: "8",
              },
            },
            data: data,
          },
        ],
      });
    },
    // 初始化景点人气排名图表
    initCheckTopChart(mydata) {
      let data = mydata.reverse();
      let chart = this.getChart("topChart");
      chart.setOption(
        {
          title: {
            text: "人气排名",
            left: "0",
            top: "0",
          },
          grid: {
            left: "0",
            right: "15%",
            bottom: "0",
            top: "60px",
            containLabel: true,
          },
          xAxis: {
            type: "value",
            show: false,
          },
          yAxis: {
            type: "category",
            show: false,
          },
          color: ["#227cff"],
          series: [
            {
              data: data.map((item) => item.count),
              type: "bar",
              barCategoryGap: "50%",
              label: {
                show: true,
                color: "black",
                position: "right",
                formatter: (params) => {
                  let i = params.dataIndex;
                  return data[i].count;
                },
              },
            },
            {
              name: "合计",
              type: "bar",
              stack: "total",
              silent: true,

              label: {
                show: true,
                color: "#858386",
                verticalAlign: "bottom",
                // lineHeight:55,
                offset: [0, -20],
                // algin: "center",
                position: "bottomRight",
                formatter: (params) => {
                  let i = params.dataIndex;
                  return data[i].name;
                },
              },
              tooltip: {
                show: false,
              },
              data: data.map(() => 0),
            },
          ],
        },
        true
      );
      chart.resize();
    },
  },
};
</script>
<style>
:focus {
  outline: 0;
}
</style>
<style scoped lang="less">
.chart {
  width: 100%;
  padding: 0.3rem 0.2rem;
  box-sizing: border-box;
  font-size: 0.16rem;
  background-color: #f7f7f7;
  .background {
    padding: 0.2rem 0.1rem 0.1rem 0.1rem;
    box-sizing: border-box;
    border-radius: 0.05rem;
    background-color: #fff;
    margin-top: 0.2rem;
  }
  #Timeline {
    width: 100%;
    height: 2.5rem;
  }
  #topChart {
    width: 100%;
    // height: 4rem;
  }
  #NewOld,
  #gender {
    width: 35%;
    height: 1.5rem;
  }
  #age {
    width: 35%;
    height: 3rem;
  }
  .pieRight {
    width: 65%;
    color: #656565;
    .pie-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;
      font-size: 0.12rem;
      .pie-item-title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.02rem 0;
        box-sizing: border-box;
        border-radius: 0.1rem;
        width: 38%;
        span {
          width: 0.05rem;
          height: 0.05rem;
          border-radius: 50%;
          display: inline-block;
          margin-right: 0.03rem;
        }
      }
      .pie-item-title1 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 38%;
        .pie-item-title-inner {
          padding: 0.02rem 0.1rem;
          box-sizing: border-box;
          border-radius: 0.15rem;
        }
        span {
          width: 0.05rem;
          height: 0.05rem;
          border-radius: 50%;
          display: inline-block;
          margin-right: 0.03rem;
        }
      }
      .pie-item-value {
        width: 28%;
      }
      .pie-item-rate {
        width: 28%;
      }
    }
    .pie-item:nth-child(1) {
      margin-top: 0;
    }
  }
  .tours {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #b4b4b4;
    font-size: 0.17rem;
    .el-dropdown-link {
      border-radius: 0.3rem;
      background-color: #f2f2fa;
      padding: 0 0.2rem;
      box-sizing: border-box;
      line-height: 0.4rem;
      width: 2.4rem;
      font-size: 0.18rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .add {
    background-image: url("../assets/add.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 1.2rem;
    margin-top: 0.17rem;
    padding: 0.1rem 0 0.2rem 0.25rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    color: #fff;
    .add-name {
      font-size: 0.18rem;
      font-weight: 700;
      span {
        font-size: 0.16rem;
        margin-left: 0.05rem;
      }
    }
    .add-value {
      font-size: 0.4rem;
      font-weight: 700;
      span {
        font-size: 0.12rem;
      }
    }
  }
  .date {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #b4b4b4;
    margin-top: 0.2rem;
    font-size: 0.17rem;
    padding: 0 0.05rem;
    box-sizing: border-box;
    .date-title {
      color: #b4b4b4;
      font-size: 0.17rem;
    }
    .date-text {
      width: 70%;
      font-size: 0.13rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .date-item {
        background-color: #f2f2fa;
        padding: 0.03rem 0.1rem;
        color: #000;
        border-radius: 0.2rem;
      }
      .active {
        background-color: #eefaf6;
        color: #6fd16a;
      }
    }
  }
  .view {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #fff;
    margin-top: 0.3rem;
    .view-item {
      width: 48%;
      height: 1.6rem;
      border-radius: 0.1rem;
      padding: 0.15rem 0 0.2rem 0.15rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .view-title {
        font-size: 0.17rem;
      }
      .view-data {
        font-weight: 700;
        font-size: 0.24rem;
      }
    }
    .appointCount {
      background-color: #516bda;
    }
    .checkinCount {
      background-color: #6fd16c;
    }
  }
  .health {
    margin-top: 0.3rem;
    .health-title {
      font-size: 0.18rem;
      margin-bottom: 0.1rem;
    }
    .health-data {
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 0.15rem;
        margin-right: 0.1rem;
      }
      div {
        font-size: 0.22rem;
      }
      .health-item1 {
        color: #6fd16c;
      }
      .health-item2 {
        color: #f8a24d;
      }
      .health-item3 {
        color: #ff1e26;
      }
    }
  }

  .Timelines {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.2rem;
    box-sizing: border-box;
    div {
      padding: 0.05rem 0.2rem;
      border-radius: 0.2rem;
      font-size: 0.13rem;
      display: flex;
      align-items: center;
      span {
        width: 0.05rem;
        height: 0.05rem;
        border-radius: 50%;
        display: inline-block;
        margin-right: 0.03rem;
      }
    }
  }
  .more {
    width: 100%;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
    text-align: center;
    color: #a9cffa;
    font-size: 0.12rem;
  }
}
</style>